import { Alert } from '@mui/material';
import styled from 'styled-components';

export const StyledAlert = styled(Alert)`
  width: 100%;
`;
